<template>
  <div>
    <div v-if="loading" style="width: 100%; height: 100%; position: fixed;">Loading...</div>
    <div v-else>
      <div v-if="errors">
        <p v-for="(error, idx) in errors" :key="idx">{{ error }}</p>
      </div>
      <h1 style="font-family: arial">You've reached the secret page...</h1>
      <p>The server secret is...{{ serverSecret || 'not found...'}}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AdminSecret',
  data () {
    return {
      loading: true,
      serverSecret: '',
      errors: []
    }
  },
  computed: {
    ...mapState('auth', [
      'token'
    ])
  },
  created () {
    this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    this.axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/secret`)
      .then(response => {
        this.serverSecret = response.data
        this.loading = false
      })
      .catch(e => {
        this.errors.push(e)
        if (e.response.status === 401) {
          this.$router.push({ name: 'AdminLogin' })
        }
      })
  }
}
</script>
